import { useQuery, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { MfaStatus } from "../types/Mfa.type";

export const MFA_STATUS_KEY = "mfa-status";

const fetchMfaStatus = async (): Promise<MfaStatus> => {
	const response = await apiV2.get("/mfa/status");
	return (response.data as { data?: MfaStatus })?.data ?? response.data;
};

export const useMfaStatus = (enabled = true) => {
	const { data, isLoading, error, refetch } = useQuery<MfaStatus>({
		queryKey: [MFA_STATUS_KEY],
		queryFn: fetchMfaStatus,
		enabled,
	});

	return { data, isLoading, error, refetch };
};

export const useInvalidateMfaStatus = () => {
	const queryClient = useQueryClient();
	return () => queryClient.invalidateQueries({ queryKey: [MFA_STATUS_KEY] });
};
